export const rolesID = {
  ROLE_PARTICIPANT_BONUSES_PROGRAM: 1,
  ROLE_PATANCIAL_PARTICIPANT_BONUSES_PROGRAM: 2,
  ROLE_CONTENT_MANAGER: 3,
  ROLE_MANAGER_SUPPORT: 4,
  ROLE_BONUS_MANAGER: 5,
  ROLE_MERCHANT: 6,
  ROLE_SUPERVISER_TP: 7,
  ROLE_ADMINISTRATOR: 8,
  ROLE_MOBILE_APP: 9,
};
